import React from "react";

const Footer = () => {
  return (
    <footer className="bg-light p-3 text-center">
      <div className="logo" />
      <p>
        ReVolta Admin Console &copy;2025 v{window.appConfig && window.appConfig.version}
      </p>
    </footer>
  );
};

export default Footer;